import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import { ResponsiveProvider } from './context/ResponsiveContext'
import Login from './pages/Login'
import ResetPassword from './pages/ResetPassword'
import Dashboard from './pages/Dashboard'
import LinkAccount from './pages/LinkAccount'
import MainTabs from './pages/MainTabs'
import Schedule from './pages/Schedule'
import Assignments from './pages/Assignments'
import Attendance from './pages/Attendance'
import Exams from './pages/Exams'
import ExamSessionLanding from './pages/ExamSessionLanding'
import ExamAttemptPlayer from './pages/ExamAttemptPlayer'
import ExamAttemptReview from './pages/ExamAttemptReview'

function Protected({ children }) {
  const { session, loading } = useAuth()
  if (loading) return <div style={{ textAlign: 'center', margin: '2rem' }}>جاري التحميل...</div>
  if (!session) return <Navigate to="/login" replace />
  return children
}

export default function App() {
  return (
    <AuthProvider>
      <ResponsiveProvider>
        <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/link-account"
          element={(
            <Protected>
              <LinkAccount />
            </Protected>
          )}
        />
        <Route
          path="/schedule"
          element={(
            <Protected>
              <Schedule />
            </Protected>
          )}
        />
        <Route
          path="/attendance"
          element={(
            <Protected>
              <Attendance />
            </Protected>
          )}
        />
        <Route
          path="/assignments"
          element={(
            <Protected>
              <Assignments />
            </Protected>
          )}
        />
        <Route
          path="/exams"
          element={(
            <Protected>
              <Exams />
            </Protected>
          )}
        />
        <Route
          path="/exams/:sessionId"
          element={(
            <Protected>
              <ExamSessionLanding />
            </Protected>
          )}
        />
        <Route
          path="/exams/:sessionId/attempt/:attemptId"
          element={(
            <Protected>
              <ExamAttemptPlayer />
            </Protected>
          )}
        />
        <Route
          path="/exams/:sessionId/attempt/:attemptId/review"
          element={(
            <Protected>
              <ExamAttemptReview />
            </Protected>
          )}
        />
        <Route
          path="/"
          element={
            <Protected>
              <MainTabs />
            </Protected>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ResponsiveProvider>
    </AuthProvider>
  )
}
